import React from 'react';
import PropTypes from 'prop-types';

import DataProvider from '../../HO/State/DataProvider';
import { Provider } from './VoiceTemplatesContext';

const VoiceTemplatesProvider = ({ children, form }) => (
  <DataProvider route="voiceTemplates" Provider={Provider} form={form}>
    {children}
  </DataProvider>
);

VoiceTemplatesProvider.propTypes = {
  children: PropTypes.node.isRequired,
  form: PropTypes.instanceOf(Object),
};

VoiceTemplatesProvider.defaultProps = {
  form: null,
};

export default VoiceTemplatesProvider;
